import { Link } from 'react-router-dom';
import { Panel } from '@/components/shared/Panel';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="auth-page">
      <div className="auth-page__backdrop" />
      <Panel title="Page not found" description="This route does not exist in the current Woof Woof MVP.">
        <Link to="/" className="button button--secondary">
          Return Home
        </Link>
      </Panel>
    </div>
  );
}
